import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=68423e27&scoped=true&"
import script from "./InvoicesTable.vue?vue&type=script&lang=ts&"
export * from "./InvoicesTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=68423e27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68423e27",
  null
  
)

export default component.exports